export const SET_LABELS = 'SET_LABELS';
export const REMOVE_ALL_REPORT_LABEL_VALUES = 'REMOVE_ALL_REPORT_LABEL_VALUES';
export const SET_REPORTING_DATE_RANGE = 'SET_REPORTING_DATE_RANGE';

export const SET_REPORTING_FLOW = 'SET_REPORTING_FLOW';
export const SET_FLOW_LIST_OPTIONS = 'SET_FLOW_LIST_OPTIONS';

export const CLEAR_REPORTING_LIST_OPTIONS = 'CLEAR_REPORTING_LIST_OPTIONS';

export const SET_REPORT_LOADING = 'SET_REPORT_LOADING';
